export default __webpack_public_path__ + "media/images/landing-40-550x420-82fd3aa473d17be7a97721cedfb4144b.jpg";